import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { reset } from 'redux-form';
import List from './List';
import Filter from './Filter';
import { loadLoyalChildrenReport, exportLoyalChildren } from './actions';
import { initialize } from 'redux-form';

class LoyalChildrenReport extends Component {

	constructor(props) {
		super(props);
		this.handleFilterSubmit = this.handleFilterSubmit.bind(this);
		this.handleListEvent = this.handleListEvent.bind(this);
	}

	componentDidMount() {
		const { filter, sortKey, sortDirection, pageNumber, pageSize } = this.props.pagination;

		this.loadData({ filter, sortKey, sortDirection, pageNumber, pageSize });
		this.props.initializeFilter(filter);
	}

	handleFilterSubmit(options) {
		const { isExport, ...filter } = options;
		const { sortKey, sortDirection, pageSize } = this.props.pagination;
		this.loadData({ filter, sortKey, sortDirection, pageNumber: 1, pageSize });
		if (isExport)
			this.exportData(filter);
	}

	handleListEvent(listPagination) {
		const { filter } = this.props.pagination;
		this.loadData({ filter, ...listPagination });
	}

	loadData({ filter, sortKey, sortDirection, pageNumber, pageSize }) {
		const { loadReport } = this.props;
		loadReport({ ...filter, sortKey, sortDirection, pageSize, pageNumber });
	}

	exportData(filter) {
		this.props.exportLoyalChildren(filter);
	}

	render() {
		const { data, requireChildSchool } = this.props;

		return (
			<div>
				<Filter
					onSubmit={this.handleFilterSubmit}
					loading={this.props.pagination.loading || this.props.export.loading}
				/>
				<List
					data={data}
					onFetchData={this.handleListEvent}
					requireChildSchool={requireChildSchool}
					{...this.props.pagination}
				/>
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	
	const {
		pagination,
		exports,
		entities: { loyalChildrenReport },
		configuration: { franchisor }
	} = state;

	const loyalChildrenReportPagination = pagination.loyalChildrenReport.all || { ids: [], pageNumber: 1, pageSize: 10 };
	const loyalChildrenExport = exports.loyalChildren.all || {};

	return {
		data: loyalChildrenReportPagination.ids.map(id => loyalChildrenReport[id]),
		pagination: loyalChildrenReportPagination,
		export: loyalChildrenExport,
		requireChildSchool: franchisor.requireChildSchool
	};
};

const mapDispatchToProps = {
	loadReport: loadLoyalChildrenReport,
	exportLoyalChildren,
	resetFilter: () => reset('loyalChildrenReportFilter'),
	initializeFilter: (data, fields) => initialize('loyalChildrenReportFilter', data, fields)
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(LoyalChildrenReport));